// extracted by mini-css-extract-plugin
export default {"title":"TitleWithContext_title__1mf0n","question":"TitleWithContext_question__QN3hT"};